import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { BookCard, EmptyState } from "@/components/cards";

export default function Collection({ kind }) {
  const { slug } = useParams();
  const [meta, setMeta] = useState(null);
  const [books, setBooks] = useState([]);
  const endpoint = kind === "genre" ? "genres" : "tropes";

  useEffect(() => {
    api.get(`/${endpoint}`).then((r) => setMeta(r.data.find((x) => x.slug === slug)));
    const key = kind === "genre" ? "genre" : "trope";
    api.get(`/books?${key}=${slug}`).then((r) => setBooks(r.data));
  }, [slug, kind]); // eslint-disable-line

  return (
    <div className="fade-in">
      <div className="relative h-56 md:h-72 overflow-hidden">
        {meta?.image && <img src={meta.image} alt="" className="absolute inset-0 h-full w-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-black/40" />
        <div className="relative max-w-[1400px] mx-auto px-4 lg:px-8 h-full flex flex-col justify-end pb-8">
          <p className="track-label text-xs text-primary">{kind === "genre" ? "Genre" : "Trope"}</p>
          <h1 className="text-4xl md:text-5xl font-display font-bold mt-2">{meta?.name || slug}</h1>
          {meta?.description && <p className="text-muted-foreground mt-2 max-w-2xl">{meta.description}</p>}
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10">
        <p className="text-sm text-muted-foreground mb-4">{books.length} stories</p>
        {books.length ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {books.map((b) => <BookCard key={b.id} book={b} />)}
          </div>
        ) : <EmptyState title="No stories here yet" subtitle="New stories in this collection are coming soon." />}
      </div>
    </div>
  );
}
